import React, { useMemo, useCallback } from 'react';

import type { LunaClient } from '@vlabs/api-bindings';
import { apiContainer } from '@vlabs/api-bindings';
import { Page, PageContent } from '@vlabs/monokit/shared/ui/page';
import {
  Panel, Table, TableCells, useTableHook,
} from '@vlabs/uikit';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';

function AccountListPage(): React.JSX.Element {
  const { t } = useTranslation();

  const tableProps = useTableHook(useCallback(async () => {
    const { data } = await (apiContainer.lunaClient as LunaClient).accounts.getAll();
    return data;
  }, []), { paginationType: 'offsetBased' });

  const columns = useMemo(() => ([
    {
      Header:
        (<TableCells.TableHeaderCell
          label={t('accounts:table.columns.login.header.label')}
          title={t('accounts:table.columns.login.header.title')}
        />),
      accessor: 'login',
      width: 100,
    },
    {
      Header:
        (<TableCells.TableHeaderCell
          label={t('accounts:table.columns.description.header.label')}
          title={t('accounts:table.columns.description.header.title')}
        />),
      accessor: 'description',
      width: 100,
    },
    {
      Header:
        (<TableCells.TableHeaderCell
          label={t('accounts:table.columns.account_type.header.label')}
          title={t('accounts:table.columns.account_type.header.title')}
        />),
      accessor: 'account_type',
      width: 100,
    },
    {
      Header:
        (<TableCells.TableHeaderCell
          label={t('accounts:table.columns.create_time.header.label')}
          title={t('accounts:table.columns.create_time.header.title')}
        />),
      accessor: 'create_time',
      width: 100,
      Cell: TableCells.DateCell,
    },
    {
      Header:
        (<TableCells.TableHeaderCell
          label={t('accounts:table.columns.last_update_time.header.label')}
          title={t('accounts:table.columns.last_update_time.header.title')}
        />),
      accessor: 'last_update_time',
      width: 100,
      Cell: TableCells.DateCell,
    },
  ]), [t]);

  return (
    <Page>
      <PageContent>
        <Panel className="Global__Table_fullScreen PanelAutoHeight">
          <Table
            {...tableProps}
            columns={columns}
            disableSortBy={false}
            rowProps={(row) => ({ 'data-account-id': row.original?.account_id })}
          />
        </Panel>
      </PageContent>
    </Page>
  );
}

export default connect()(AccountListPage);
